module.exports = function() {
  return new Worker(__webpack_public_path__ + "09738372c92c145f0a0d.worker.js");
};